module.exports = __webpack_public_path__ + "static/Danville-e8e99fac27e7f2d5ea631d3a4f70377f.jpg";